import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyOwned } from 'src/app/models/company/company-models.model';
import { Stage } from './stage.model';

export enum InspectionItemCodeCategory {
  CRITICAL = 'ernstig',
  MAJOR = 'serieus',
  MINOR = 'gering',
}

@HateoasResource('inspectionitemcode')
export class InspectionItemCode extends CompanyOwned {
  public categorie!: InspectionItemCodeCategory;
  public groep: string | undefined;
  public methode!: string;
  public naam!: string;
  public verborgen!: boolean;
  public stadia: Stage[] = [];

  //CUSTOM
  public groepResolved!: {
    id: string;
    naam: string;
  };
  public elementId?: string;
  public laagId?: string;
}
